import React from 'react'
import PropTypes from 'prop-types'
import { SvgIcon } from '@mui/material'

import { ReactComponent as ResidentialIcon } from 'assets/business-line/Residential.svg'
import { ReactComponent as CommercialIcon } from 'assets/business-line/Commercial.svg'
import { ReactComponent as RolloffIcon } from 'assets/business-line/Rolloff.svg'
import capitalize from 'lodash/capitalize'

const BUSINESS_LINE_ICONS = {
  Residential: ResidentialIcon,
  Commercial: CommercialIcon,
  Rolloff: RolloffIcon,
}

const BusinessLineIconRenderer = ({ businessLine = '', sx }) => {
  const normalizedBusinessLine = capitalize(businessLine.replace('.svg', '').replace(/-/g, ''))
  const Icon = BUSINESS_LINE_ICONS[normalizedBusinessLine]
  return (
    <SvgIcon fontSize="small" sx={sx}>
      {Icon && <Icon />}
    </SvgIcon>
  )
}

BusinessLineIconRenderer.propTypes = {
  businessLine: PropTypes.string.isRequired,
  sx: PropTypes.object,
}

export default BusinessLineIconRenderer
